import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskAtlassianAnalyticsRoute: InvariantJiraRoute = {
	name: 'servicedesk-atlassian-analytics',
	path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
	exact: true,
};
